var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video",style:({
  'background': _vm.data.infoItme.bjColor,
  'padding': ((_vm.data.infoItme.sBj) + " " + (_vm.data.infoItme.yeBj) + " " + (_vm.data.infoItme.xBj))
})},[(_vm.data.video.src)?_c('video',{staticClass:"video_box",attrs:{"controls":"","poster":_vm.data.fengValue ? _vm.data.infoImg.url : ''}},[_c('source',{attrs:{"src":_vm.data.video.src,"type":"video/mp4"}})]):_c('img',{staticClass:"img_box",attrs:{"src":_vm.defUpload,"alt":"defUpload"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e6d360f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/videoPreview.vue
// module id = null
// module chunks = 